/**
 * Route for `igaming-affiliate-level-ngr-ggr-ftd-report`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingAffiliateLevelNgrGgrFtdReportPage } from "../features/igaming-affiliate-level-ngr-ggr-ftd-report/IgamingAffiliateLevelNgrGgrFtdReportPage";

export const igamingAffiliateLevelNgrGgrFtdReportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-affiliate-level-ngr-ggr-ftd-report",
	component: IgamingAffiliateLevelNgrGgrFtdReportPage,
});

export default igamingAffiliateLevelNgrGgrFtdReportRoute;
